module.exports = __webpack_public_path__ + "static/alex-riley-logo-sq-acf7702b10ee1f5520927a5f84ed5ab3.jpg";